import { render, staticRenderFns } from "./DeliveryHowItWorksLine03.vue?vue&type=template&id=3bf60360&"
import script from "./DeliveryHowItWorksLine03.vue?vue&type=script&lang=js&"
export * from "./DeliveryHowItWorksLine03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports